module.exports = __webpack_public_path__ + "img/zuki.jpg.mini.7dd7dbfc.jpg";